export { GRAPHQL_PLAYGROUND_GET, GRAPHQL_POST } from '../routes/graphql/index.js'

export {
  DELETE as REST_DELETE,
  GET as REST_GET,
  OPTIONS as REST_OPTIONS,
  PATCH as REST_PATCH,
  POST as REST_POST,
  PUT as REST_PUT,
} from '../routes/rest/index.js'
